(() => {
  const root = document.querySelector('[data-mbp-root]');
  if (!root || root.dataset.mbpReady) return;
  root.dataset.mbpReady = 'true';
  const gallery = [...root.querySelectorAll(".mbp-gallery-dot")].map((dot) => [dot.dataset.gallerySrc, dot.dataset.galleryAlt]);
  const stage = root.querySelector(".mbp-gallery-stage");
  const image = root.querySelector("#mbp-hero-image");
  const count = root.querySelector("#mbp-gallery-count");
  const dots = [...root.querySelectorAll(".mbp-gallery-dot")];
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  let current = 0;
  let timer = 0;
  let userControlled = false;
  let heroVisible = true;
  let startX = 0;
  let startY = 0;
  let gestureActive = false;

  function render(index) {
    current = (index + gallery.length) % gallery.length;
    image.style.opacity = ".25";
    const preload = new Image();
    preload.onload = () => {
      image.src = gallery[current][0];
      image.alt = gallery[current][1];
      image.style.opacity = "1";
    };
    preload.src = gallery[current][0];
    count.textContent = `${current + 1} / ${gallery.length}`;
    dots.forEach((dot, indexValue) => {
      const active = indexValue === current;
      dot.classList.toggle("mbp-gallery-dot--active", active);
      dot.setAttribute("aria-current", active ? "true" : "false");
    });
  }

  function stopForUser() {
    userControlled = true;
    window.clearInterval(timer);
  }

  function startAutoplay() {
    window.clearInterval(timer);
    if (reduceMotion || userControlled || !heroVisible || document.hidden) return;
    timer = window.setInterval(() => render(current + 1), 2500);
  }

  function manualStep(direction) {
    stopForUser();
    render(current + direction);
  }

  root.querySelector(".mbp-gallery-arrow--prev").addEventListener("click", () => manualStep(-1));
  root.querySelector(".mbp-gallery-arrow--next").addEventListener("click", () => manualStep(1));
  dots.forEach((dot, index) => dot.addEventListener("click", () => { stopForUser(); render(index); }));

  function beginGesture(x, y) {
    startX = x;
    startY = y;
    gestureActive = true;
  }

  function endGesture(x, y) {
    if (!gestureActive) return;
    gestureActive = false;
    const deltaX = x - startX;
    const deltaY = y - startY;
    if (Math.abs(deltaX) < 42 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.1) return;
    manualStep(deltaX < 0 ? 1 : -1);
  }

  stage.addEventListener("pointerdown", (event) => beginGesture(event.clientX, event.clientY), {passive: true});
  stage.addEventListener("pointercancel", () => { gestureActive = false; }, {passive: true});
  stage.addEventListener("mousedown", (event) => beginGesture(event.clientX, event.clientY), {passive: true});
  stage.addEventListener("dragstart", (event) => event.preventDefault());
  window.addEventListener("pointerup", (event) => endGesture(event.clientX, event.clientY), {passive: true});
  window.addEventListener("mouseup", (event) => endGesture(event.clientX, event.clientY), {passive: true});
  stage.addEventListener("touchstart", (event) => {
    const touch = event.touches[0];
    if (touch) beginGesture(touch.clientX, touch.clientY);
  }, {passive: true});
  window.addEventListener("touchend", (event) => {
    const touch = event.changedTouches[0];
    if (touch) endGesture(touch.clientX, touch.clientY);
  }, {passive: true});
  stage.addEventListener("keydown", (event) => {
    if (event.key === "ArrowLeft") manualStep(-1);
    if (event.key === "ArrowRight") manualStep(1);
  });

  new IntersectionObserver(([entry]) => {
    heroVisible = entry.isIntersecting;
    startAutoplay();
  }, {threshold: .25}).observe(stage);
  document.addEventListener("visibilitychange", startAutoplay);
  startAutoplay();

  let quantity = 1;
  const quantityOutput = root.querySelector("[data-qty]");
  root.querySelector("[data-qty-minus]").addEventListener("click", () => {
    quantity = Math.max(1, quantity - 1);
    quantityOutput.value = quantity;
    quantityOutput.textContent = quantity;
  });
  root.querySelector("[data-qty-plus]").addEventListener("click", () => {
    quantity += 1;
    quantityOutput.value = quantity;
    quantityOutput.textContent = quantity;
  });

  const mainAdd = root.querySelector(".mbp-add-button");
  const sticky = root.querySelector(".mbp-sticky-buy");
  new IntersectionObserver(([entry]) => {
    sticky.classList.toggle("mbp-sticky-buy--visible", !entry.isIntersecting && window.scrollY > 500);
  }, {threshold: 0}).observe(mainAdd);

  const videos = [...root.querySelectorAll(".mbp-video-case video")];
  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target;
      if (entry.isIntersecting && !reduceMotion) {
        if (!video.src) {
          video.src = video.dataset.src;
          video.load();
        }
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, {rootMargin: "240px 0px", threshold: .18});
  videos.forEach((video) => {
    videoObserver.observe(video);
    const toggleVideo = () => {
      if (!video.src) { video.src = video.dataset.src; video.load(); }
      if (video.paused) video.play().catch(() => {}); else video.pause();
    };
    video.addEventListener("click", toggleVideo);
    video.addEventListener("keydown", (event) => {
      if (event.key === " " || event.key === "Enter") { event.preventDefault(); toggleVideo(); }
    });
  });
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) videos.forEach((video) => video.pause());
  });
})();
